var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLeftArrowDisabled = function SvgLeftArrowDisabled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    stroke: "#343741"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.306 14.615 16.922 20l5.384 5.384"
  }))));
};

export { SvgLeftArrowDisabled as ReactComponent };
export default __webpack_public_path__ + "26944b86ea78656d6c628313c97f8500.svg";